<template>
  <app-data-editor
    :id="id"
    title="Редактирование модели(ТМ)"
    resource="trademark-models"
    :elements="elements"
    add-message="Модель добавлена"
    edit-message="Модель изменена"
    :is-show-created-date="true"
    @change="payload => (isChanged = payload)"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
          {
            title: "TM",
            name: "trademark",
            control: {
              type: "reference",
              component: "Trademark",
              resource: "trademarks",
              required: true,
              rules: [v => !!v || ""],
              autoSetChildren: "Manufacturer",
              autoSetChildrenField: "manufacturer",
            },
          },
          {
            title: "Производитель",
            name: "manufacturer",
            control: {
              type: "reference",
              component: "Manufacturer",
              resource: "manufacturers",
              required: true,
              rules: [v => !!v || ""],
              parentField: "Trademark",
              disabled: true,
            },
          },
        ],
        [
          {
            title: "Категория",
            name: "productCategory",
            control: {
              type: "reference",
              component: "ProductCategory",
              resource: "product-categories",
            },
          },
          {
            title: "Сайт продукта",
            name: "productSite",
            control: {
              type: "text",
            },
            default: "",
          },
          {
            title: "Номенклатура",
            name: "nomenclature",
            control: {
              type: "reference",
              component: "Nomenclature",
              resource: "nomenclatures",
            },
          },
        ],
        [
          {
            title: "Страна происхождения",
            name: "country",
            control: {
              type: "reference",
              component: "Country",
              resource: "countries",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Единица измерения",
            name: "unit",
            control: {
              type: "reference",
              component: "Unit",
              resource: "units",
              required: true,
              rules: [v => !!v || ""],
            },
          },
          {
            title: "Материал",
            name: "material",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
        ],
        [
          {
            title: "Вес нетто",
            name: "weightNetto",
            control: {
              type: "text",
            },
            default: "",
          },
          {
            title: "Вес брутто",
            name: "weightBrutto",
            control: {
              type: "text",
            },
            default: "",
          },
          {
            title: "Таможенный код",
            name: "customsNumber",
            control: {
              type: "text",
            },
            default: "",
          },

          {
            title: "Размеры",
            name: "dimensions",
            control: {
              type: "text",
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
